import { render, staticRenderFns } from "./ComposerAddModal.vue?vue&type=template&id=303248ee&scoped=true"
import script from "./ComposerAddModal.vue?vue&type=script&lang=js"
export * from "./ComposerAddModal.vue?vue&type=script&lang=js"
import style0 from "./ComposerAddModal.vue?vue&type=style&index=0&id=303248ee&prod&lang=css"
import style1 from "./ComposerAddModal.vue?vue&type=style&index=1&id=303248ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303248ee",
  null
  
)

export default component.exports